import type {KitAdminState} from '@dv/kitadmin/models';

export const RECHNUNG_API = {
    name: 'base.kinderort.faktura.api',
    url: '/api',
} satisfies KitAdminState;
